import { config } from '../lib/config';

export interface AuthUser {
    id: string;
    name: string;
    phone: string;
    role: string;
    token?: string;
}

interface LoginResponse {
    success: boolean;
    message: string;
    data: {
        user: {
            uuid: string;
            username: string;
            name: string;
        };
        token: string;
    };
}

export const authService = {
    async login(username: string, password: string): Promise<AuthUser | null> {
        try {
            const response = await fetch(`${config.apiBaseUrl}/api/auth/login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ username, password }),
            });

            if (!response.ok) {
                return null;
            }

            const result: LoginResponse = await response.json();

            if (!result.success || !result.data) {
                return null;
            }

            // Map the API response to our AuthUser interface
            return {
                id: result.data.user.uuid,
                name: result.data.user.name,
                phone: '', // Not provided by API
                role: 'admin', // Default role, update if API provides it
                token: result.data.token,
            };
        } catch (error) {
            console.error('Login error:', error);
            return null;
        }
    },
};
